const pageMarker = document.querySelector('.viorra-collection-page');

if (pageMarker) {
  const groupSelectors = [
    '.facets-block-wrapper--vertical:not(theme-drawer) .facets--vertical',
    '#filters-drawer .facets--drawer',
  ];

  const panelHasActiveValue = (panel) => {
    if (panel.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked')) return true;

    return Array.from(panel.querySelectorAll('input[type="text"], input[type="number"]')).some(
      (input) => input.value.trim() !== ''
    );
  };

  const initializeGroup = (group) => {
    if (group.dataset.viorraFacetsInitialized === 'true') return;

    const panels = Array.from(group.querySelectorAll('details.facets__panel'));
    panels.forEach((panel, index) => {
      const shouldOpen = index === 0 || panelHasActiveValue(panel);
      panel.toggleAttribute('open', shouldOpen);
    });

    group.dataset.viorraFacetsInitialized = 'true';
  };

  const initializeWithin = (scope = document) => {
    groupSelectors.forEach((selector) => {
      if (scope instanceof Element && scope.matches(selector)) initializeGroup(scope);
      scope.querySelectorAll?.(selector).forEach(initializeGroup);
    });
  };

  initializeWithin(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initializeWithin(node);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
}
